/**********************************************************************
 * WARNING: This file was autogenerated by util-protos generateFiles.js
 * Do not manually edit!
 ***********************************************************************/

import {createReactQueryHook} from '../types'
import {getFeatureFlagsSemaphore} from '../api'

 export const useQueryGetFeatureFlagsSemaphore = createReactQueryHook('getFeatureFlagsSemaphore', getFeatureFlagsSemaphore)
